import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';

import { HomeItemDetail } from '@home-item-detail/entities/home-item-detail';
import { HomeFlightOffers } from '@shared/home-sections/entities/home-data.response';
import { TravelCmsHomeItemDetailPayload } from '@home/entities/travel-cms';


export const fetchHomeItemDetailAction = createAction(
  type('[Home/API] Fetch home item detail'),
  props<{ payload: TravelCmsHomeItemDetailPayload }>()
);
export const fetchHomeItemDetailSuccessAction = createAction(
  type('[Home/API] Fetch home item detail success'),
  props<{ response: HomeItemDetail }>()
);
export const homeItemDetailStoreActions = {
  fetchHomeItemDetailAction
};
export const clearHomeItemDetail = createAction(
  type('[Home/API] clear home item detail')
);
export const fetchHomeFlightOffersAction = createAction(
  type('[Home/API] Fetch home flight offers data'),
  props<{ departure: string, arrival: string, isOneWay: number }>()
);
export const fetchHomeFlightOffersSuccessAction = createAction(
  type('[Home/API] Fetch home flight offers data success'),
  props<{ response: HomeFlightOffers[] }>()
);
export const clearFlightOfferAction = createAction(
  type('[Home/API] clear flight offers')
);
